const typographyFormParamFreq = {
  true: 'New Frequency',
  false: 'Edit Frequency'
};

export default typographyFormParamFreq;
